import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  drawerOpen: false,
  showMenuItems: true,
  commentSliderOpen: false,
  commentSliderExamId: null, // New state for examId
};

const utilsSlice = createSlice({
  name: "utils",
  initialState,
  reducers: {
    handleDrawerOpen(state) {
      state.drawerOpen = true;
    },
    handleDrawerClose(state) {
      state.drawerOpen = false;
    },
    setShowMenuItems(state, action) {
      state.showMenuItems = action.payload;
    },
    setCommentSliderOpen(state, action) {
      // Callers pass either a boolean or { open, examId }; an object stored
      // as-is is truthy even when open is false, so unpack it.
      const { open, examId } =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { open: action.payload, examId: null };
      state.commentSliderOpen = Boolean(open);
      state.commentSliderExamId = examId || null;
    },
  },
});

export const { handleDrawerOpen, handleDrawerClose, setShowMenuItems, setCommentSliderOpen } = utilsSlice.actions;
export default utilsSlice.reducer;